import { SET_PPA_IS_VISIBLE } from './constants';

export const setPpaIsVisible = isVisible => ({
    type: SET_PPA_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/PPA/actions.js